import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_STAFF_REQUEST,
  GET_STAFF_SUCCESS,
  GET_STAFF_FAIL,
  DELETE_STAFF_REQUEST,
  DELETE_STAFF_SUCCESS,
  DELETE_STAFF_FAIL,
  STAFF_DETAILS_REQUEST,
  STAFF_DETAILS_SUCCESS,
  STAFF_DETAILS_FAIL,
  CREATE_STAFF_REQUEST,
  CREATE_STAFF_SUCCESS,
  CREATE_STAFF_FAIL,
  EDIT_STAFF_REQUEST,
  EDIT_STAFF_SUCCESS,
  EDIT_STAFF_FAIL,
} from "./actionTypes";
import * as actions from "./actions";
import toast from "react-hot-toast";
import axios from "axios";
import {
  getStaffRequest,
  getStaffSuccess,
  getStaffFail,
  createStaffRequest,
  createStaffSuccess,
  createStaffFail,
  getStaffDetailRequest,
  getStaffDetailSuccess,
  getStaffDetailFail,
  editStaffRequest,
  editStaffSuccess,
  editStaffFail,
  deleteStaffFail,
  deleteStaffRequest,
  deleteStaffSuccess,
} from "./actions";
import { url } from "APIs/URLS";

const getStaffsAPICall = async () => {
  try {
    const response = await axios.get(`${url}/profiles/getAllStaff`);
    console.log("data = " + response.data);
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* getAllStaffs() {
  // let token = JSON.parse(localStorage.getItem("authUser")).refresh_token;
  try {
    //   console.log(" token in function = " + token);
    const response = yield call(getStaffsAPICall);
    yield put(getStaffSuccess(response));
  } catch (error) {
    yield put(getStaffFail(error));
  }
}

//CREATE STAFF
const CreateStaffAPICall = async Staff => {
  // alert("Staff" + JSON.stringify(Staff));
  const promise = axios.post(`${url}/profiles/addstaff`, Staff, {
    // headers:{
    //   "content-type": "application/json",
    //   Authorization: `Bearer  ${token}`,
    // },
  });
  try {
    toast.promise(promise, {
      loading: "Registering Staff...",
      success: "Staff Registered Successfully",
      error: "Error Registering Staff",
    });
    const response = await promise;
    console.log("data = " + response.data);
    return response.data;
  } catch (error) {
    console.log("error in saga = " + error);
    throw error;
  }
};

function* createStaff({ payload: Staff }) {
  // let token = JSON.parse(localStorage.getItem("authUser")).refresh_token;
  // alert(JSON.stringify(Staff));
  try {
    const response = yield call(CreateStaffAPICall, Staff);
    console.log(typeof response);
    yield put(createStaffSuccess(response));
    window.location.href = "/stafflist";
  } catch (error) {
    console.log("error in function", error.response.data);
    yield put(createStaffFail(error));
  }
}

///////////STAFF DETAILS
const getDetailAPICall = async email => {
  try {
    const response = await axios.get(`${url}/profiles/staffdetails/${email}`, {
      // headers: {
      //   "content-type": "application/json",
      //   Authorization: `Bearer  ${token}`,
      // },
    });
    console.log("API CALL response = " + response.data);
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* getDetail({ payload: email }) {
  // let token = JSON.parse(localStorage.getItem("authUser")).refresh_token;
  try {
    const response = yield call(getDetailAPICall, email);
    yield put(getStaffDetailSuccess(response));
  } catch (error) {
    yield put(getStaffDetailFail(error));
  }
}

///////////UPDATE

const UpdateStaffAPICall = async (Staff, email) => {
  console.log("Staff email = " + Staff);
  const promise = axios.put(`${url}/profiles/updatestaff/${email}`, Staff, {
    headers: {
      "content-type": "application/json",
      // Authorization: `Bearer  ${token}`,
    },
  });
  console.log("promise = " + promise);
  try {
    toast.promise(promise, {
      loading: "Updating Staff...",
      success: "Staff Updated Successfully",
      error: "Error Updating Staff",
    });
    const response = await promise;
    console.log("reponse=await promise", response);
    console.log("reponse.data", response.data);
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* onUpdateStaff({ payload: { Staff, email } }) {
  // let token = JSON.parse(localStorage.getItem("authUser")).refresh_token;
  try {
    console.log("Staff = " + email);
    const response = yield call(UpdateStaffAPICall, Staff, email);
    console.log("Update data = " + response);
    yield put(editStaffSuccess(response));
  } catch (error) {
    yield put(editStaffFail(error));
  }
}

//DELETE STAFF

const deleteStaffAPI = async Staff => {
  const myPromise = axios.delete(
    `${url}/profiles/deletestaff/${Staff.email}`
    // {
    //   headers: {
    //     "content-type": "application/json",
    //     Authorization: `Bearer  ${token}`,
    //   },
    // }
  );
  try {
    toast.promise(myPromise, {
      loading: "Deleting Staff..",
      success: "Staff Deleted",
      error: "Error Deleting Staff",
    });

    const response = await myPromise;
    console.log("data = " + response.data);
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};
function* onDeleteStaff({ payload: Staff }) {
  // let token = JSON.parse(localStorage.getItem("authUser")).refresh_token;
  try {
    const response = yield call(deleteStaffAPI, Staff);
    yield put(deleteStaffSuccess(response));
  } catch (error) {
    yield put(deleteStaffFail(error));
  }
}

function* StaffSaga() {
  yield takeEvery(GET_STAFF_REQUEST, getAllStaffs);
  yield takeEvery(CREATE_STAFF_REQUEST, createStaff);
  yield takeEvery(STAFF_DETAILS_REQUEST, getDetail);
  yield takeEvery(DELETE_STAFF_REQUEST, onDeleteStaff);
  yield takeEvery(EDIT_STAFF_REQUEST, onUpdateStaff);
}

export default StaffSaga;
